module.exports = __webpack_public_path__ + "img/img127.ce93f783.svg";